import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import ReactTable from 'react-table'
import { actions } from '../../redux/modules/contactsActions'
import { actions as vendorActions } from '../../redux/modules/jobFunctions/jobVendorActions'
import 'react-table/react-table.css'
import moment from 'moment'
import { Form, Modal, AutoComplete, Icon, Input, message, Popconfirm, Button, Tooltip } from 'antd'
import { convertToOption, filterCaseInsensitive } from '../../util'
import _ from 'lodash'
import Phones from '../../components/contacts/Phones'
import Emails from '../../components/contacts/Emails'
import Notes from '../../components/contacts/Notes'
import Jobs from '../../components/contacts/Jobs'
import Leads from '../../components/contacts/Leads'
import history from '../../history'
import PaginationComponent from '../../components/PaginationComponent'
import { TextMask, SpanAdapter } from 'react-text-mask-hoc'
import OrganizationQuickAdd from '../../components/organization/OrganizationQuickAdd'
import { actions as organizationsActions } from '../../redux/modules/organizationsActions'
import { getSelectedOrganization } from '../../util'
import NumberFormat from 'react-number-format'

const propTypes = {}
const FormItem = Form.Item

class Contacts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false,
      currentContact: null,
      currentContactId: null,
      emailAddEditContainer: false,
      phoneAddEditContainer: false,
      contactsLoading: true,
      currentNote: null,
      currentNoteId: null,
      phoneNumber: null,
      mobilePhoneNumber: null
    }

    this.props.getContactList()
    this.props.getAllOrganizations()
  }

  componentDidMount() {
    this.verifyShortcut()
  }

  componentDidUpdate(prevProps) {
    const { contacts } = this.props.contactsActions
    const { contactsPrev } = prevProps
    if (contacts && contacts.data && this.state.contactsLoading) {
      if (contactsPrev !== contacts) {
        this.verifyShortcut()
        this.setState({
          contactsLoading: false
        })
      }
    }
  }

  verifyShortcut() {
    const { contacts } = this.props.contactsActions
    const contactId = this.props.match.params.contactId
    if (contactId) {
      if (contacts && contacts.data) {
        const highLightContact = _.filter(
          contacts.data,
          contact => contact.id === parseInt(contactId, 10)
        )
        if (highLightContact.length > 0) {
          this.handleRowClick(highLightContact[0])
        }
      }
    }
  }

  handleOpenModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleCloseModal = () => {
    const form = this.props.form
    form.resetFields()
    this.setState({
      modalVisible: false,
      currentContact: null,
      // close email stuff
      emailAddEditContainer: false,
      emailContent: null,
      emailType: null,
      currentEmailData: null,
      // close phone stuff
      phoneAddEditContainer: false,
      phoneContent: null,
      phoneType: null,
      currentPhoneData: null,
      // close notes stuff
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowClick = row => {
    this.props.getContactEmails({ contactId: row.id })
    this.props.getContactPhones({ contactId: row.id })
    this.props.getContactNote({ contactId: row.id })
    this.props.getContactJobs({ contactId: row.id })
    this.props.getContactLeads({ contactId: row.id })
    this.setState({
      modalVisible: true,
      currentContact: row,
      currentContactId: row.id
    })
  }

  handleCreateContact = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.organization_id = getSelectedOrganization(
        this.props.organizationsActions.payload.data,
        values.organization_id
      )

      // get the unformatted phone number
      values.phone_number = this.state.phoneNumber
      values.mobile_number = this.state.mobilePhoneNumber

      this.props.createContactIndividual({
        content: values,
        userId: this.props.authentication.user.userId
      })

      form.resetFields()
      message.success('Contact created')
      this.setState({
        modalVisible: false,
        currentContact: null
      })
    })
  }

  getSelectedOrganization = value => {
    const organizations = _.get(this.props, 'organizationsActions.payload.data')
    const selectedOrganization = organizations.find(organization => organization.name === value)
    return selectedOrganization ? +selectedOrganization.id : +value
  }

  handleEditContact = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.organization_id = this.getSelectedOrganization(values.organization_id)

      // get the unformatted phone number
      values.phone_number = this.state.phoneNumber
      values.mobile_number = this.state.mobilePhoneNumber

      this.props.editContactIndividual({
        content: values,
        contactId: this.state.currentContactId,
        userId: this.props.authentication.user.userId
      })

      form.resetFields()
      message.success('Contact edited')
      this.setState({
        modalVisible: false,
        currentContact: null,
        currentContactId: null
      })
    })
  }

  handleDeleteContact = () => {
    const form = this.props.form

    this.props.deleteContactIndividual({
      contactId: this.state.currentContactId
    })

    form.resetFields()
    message.success('Contact deleted')
    this.setState({
      modalVisible: false,
      currentContact: null,
      currentContactId: null
    })
  }

  handleToggleEmailEditArea = () => {
    if (this.state.emailContent) {
      this.setState({
        emailAddEditContainer: true,
        emailContent: null,
        emailType: null,
        currentEmailData: null
      })
    } else {
      this.setState({
        emailAddEditContainer: !this.state.emailAddEditContainer
      })
    }
  }

  handleTogglePhoneEditArea = () => {
    if (this.state.phoneContent) {
      this.setState({
        phoneAddEditContainer: true,
        phoneContent: null,
        phoneType: null,
        currentPhoneData: null
      })
    } else {
      this.setState({
        phoneAddEditContainer: !this.state.phoneAddEditContainer
      })
    }
  }

  onEmailInputChange = e => {
    this.setState({
      emailContent: e.target.value
    })
  }

  onPhoneInputChange = e => {
    this.setState({
      phoneContent: e.target
    })
  }

  onChangePhoneType = e => {
    this.setState({
      phoneType: e
    })
  }

  onChangeEmailType = e => {
    this.setState({
      emailType: e
    })
  }

  handleAddEditEmail = () => {
    if (this.state.currentEmailId) {
      // edit
      let editParam = {
        emailId: this.state.currentEmailId,
        contactId: this.state.currentContact.id,
        address: this.state.emailContent
      }
      if (this.state.emailType) {
        editParam.emailType = this.state.emailType
      }

      this.props.editEmail(editParam)

      message.success('Email edited')
      this.setState({
        emailAddEditContainer: false,
        currentEmailId: null,
        currentEmailData: null
      })
    } else {
      // add
      this.props.addEmail({
        contactId: this.state.currentContact.id,
        address: this.state.emailContent,
        emailType: this.state.emailType
      })

      message.success('Email added')
      this.setState({
        emailAddEditContainer: false,
        emailContent: null,
        emailType: null
      })
    }
  }

  handleRowEmailClick = row => {
    this.setState({
      currentEmailId: row.id,
      currentEmailData: row,
      emailContent: row.address,
      emailAddEditContainer: true
    })
  }

  handleDeleteEmail = () => {
    this.props.deleteEmail({
      emailId: this.state.currentEmailId,
      contactId: this.state.currentContactId
    })

    message.success('Email deleted')
    this.setState({
      emailAddEditContainer: false,
      currentEmailId: null,
      currentEmailData: null
    })
  }

  // PHONE THINGS
  handleAddEditPhone = () => {
    if (this.state.currentPhoneId) {
      // edit
      this.props.editPhone({
        phoneId: this.state.currentPhoneId,
        contactId: this.state.currentContact.id,
        number: this.state.phoneContent,
        phoneType: this.state.phoneType
      })

      message.success('Phone edited')
      this.setState({
        phoneAddEditContainer: false,
        currentPhoneId: null,
        currentPhoneData: null
      })
    } else {
      // add
      this.props.addPhone({
        contactId: this.state.currentContact.id,
        number: this.state.phoneContent,
        phoneType: this.state.phoneType
      })

      message.success('Phone added')
    }
    this.setState({
      phoneAddEditContainer: false,
      phoneContent: null,
      phoneType: null,
      currentPhoneData: null
    })
  }

  handleRowPhoneClick = row => {
    this.setState({
      currentPhoneId: row.id,
      currentPhoneData: row,
      phoneContent: row.number,
      phoneType: row.type,
      phoneAddEditContainer: true
    })
  }

  handleDeletePhone = () => {
    this.props.deletePhone({
      phoneId: this.state.currentPhoneId,
      contactId: this.state.currentContactId
    })

    message.success('Phone deleted')
    this.setState({
      phoneAddEditContainer: false,
      currentPhoneId: null,
      currentPhoneData: null
    })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createContactNote({
      content: params,
      userId: this.props.authentication.userId,
      contactId: this.state.currentContactId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editContactNote({
      content: params,
      noteId: this.state.currentNoteId,
      contactId: this.state.currentContactId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteContactNote({
      noteId: this.state.currentNoteId,
      contactId: this.state.currentContactId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  // jobs
  handleRowJobClick = row => {
    history.push(`/jobView/${row.id}/${row.type}`)
  }

  // leads
  handleRowLeadsClick = row => {
    history.push(`/leadView/${row.id}`)
  }

  emailValidator = (rule, value, callback) => {
    const form = this.props.form
    if (value) {
      callback()
      if (_.isEmpty(form.getFieldValue('phone_number'))) {
        form.validateFields(['phone_number'], { force: true })
      }

      if (_.isEmpty(form.getFieldValue('mobile_number'))) {
        form.validateFields(['mobile_number'], { force: true })
      }
    } else {
      if (
        _.isEmpty(form.getFieldValue('phone_number')) &&
        _.isEmpty(form.getFieldValue('mobile_number')) &&
        !this.state.currentContact
      ) {
        callback('You must fill in at least: E-mail, Phone Number or Mobile Number')
      } else {
        callback()
      }
    }
  }

  phoneValidator = (rule, value, callback) => {
    const form = this.props.form
    if (value && value.indexOf('_') == -1) {
      callback()
      if (_.isEmpty(form.getFieldValue('email'))) {
        form.validateFields(['email'], { force: true })
      }

      if (_.isEmpty(form.getFieldValue('mobile_number'))) {
        form.validateFields(['mobile_number'], { force: true })
      }
    } else {
      if (
        _.isEmpty(form.getFieldValue('email')) &&
        _.isEmpty(form.getFieldValue('mobile_number')) &&
        !this.state.currentContact
      ) {
        callback('You must fill in at least: E-mail, Phone Number or Mobile Number')
      } else {
        callback()
      }
    }
  }

  mobileValidator = (rule, value, callback) => {
    const form = this.props.form
    if (value && value.indexOf('_') == -1) {
      callback()
      if (_.isEmpty(form.getFieldValue('email'))) {
        form.validateFields(['email'], { force: true })
      }

      if (_.isEmpty(form.getFieldValue('phone_number'))) {
        form.validateFields(['phone_number'], { force: true })
      }
    } else {
      if (
        _.isEmpty(form.getFieldValue('phone_number')) &&
        _.isEmpty(form.getFieldValue('email')) &&
        !this.state.currentContact
      ) {
        callback('You must fill in at least: E-mail, Phone Number or Mobile Number')
      } else {
        callback()
      }
    }
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.authentication.user.userId
    })
    setTimeout(() => {
      this.props.getAllOrganizations()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '' && this.props.organizationsActions.payload)
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.organizationsActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.organizationsActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  render() {
    const { contacts } = this.props.contactsActions
    const { currentContact } = this.state
    const { getFieldDecorator } = this.props.form
    const allOrganizations =
      this.props.organizationsActions &&
      this.props.organizationsActions.payload &&
      this.props.organizationsActions.payload.data

    const loadingContacts = _.get(this.props, 'contactsActions.loading')
    if (!contacts) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <OrganizationQuickAdd
            modalVisible={this.state.quickAddModalVisibility}
            handleCancel={this.handleCancelQuickAdd}
            handleQuickAddOrganization={this.handleQuickAddOrganization}
          />
          <Modal
            visible={this.state.modalVisible}
            title="Contacts"
            okText={currentContact ? 'Save Changes' : 'Add Contact'}
            onCancel={this.handleCloseModal}
            onOk={currentContact ? this.handleEditContact : this.handleCreateContact}
            width={currentContact ? '90%' : 800}
            maskClosable={false}
          >
            <Form layout="vertical">
              {currentContact && (
                <div className="row" style={{ marginBottom: '15px', marginTop: '15px' }}>
                  <div className="col-md-3">
                    Created by:
                    <strong>{` ${currentContact.created_by_first_name} ${
                      currentContact.created_by_last_name
                    }`}</strong>
                  </div>
                  <div className="col-md-3">
                    Updated by:
                    <strong>{` ${currentContact.updated_by_first_name} ${
                      currentContact.updated_by_last_name
                    }`}</strong>
                  </div>
                  <div className="col-md-3">
                    Created date:{' '}
                    <strong>{moment.utc(currentContact.created_date).format('M/D/YYYY')}</strong>
                  </div>
                  <div className="col-md-3">
                    Updated date:{' '}
                    <strong>{moment.utc(currentContact.updated_date).format('M/D/YYYY')}</strong>
                  </div>
                </div>
              )}
              <FormItem label="Organization">
                {getFieldDecorator('organization_id', {
                  rules: [
                    {
                      required: true,
                      message: 'Must choose an organization.'
                    }
                  ],
                  initialValue: currentContact ? currentContact.organization_name : ''
                })(
                  <AutoComplete
                    dataSource={convertToOption(allOrganizations)}
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    placeholder="Search for a vendor"
                    onBlur={this.handleBlurOrganization}
                  >
                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                  </AutoComplete>
                )}
              </FormItem>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Name">
                    {getFieldDecorator('first_name', {
                      rules: [
                        {
                          required: true,
                          message: 'Name cannot be blank.'
                        }
                      ],
                      initialValue: currentContact ? currentContact.first_name : ''
                    })(<Input />)}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Last Name">
                    {getFieldDecorator('last_name', {
                      rules: [
                        {
                          required: true,
                          message: 'Last Name cannot be blank.'
                        }
                      ],
                      initialValue: currentContact ? currentContact.last_name : ''
                    })(<Input />)}
                  </FormItem>
                </div>
              </div>
              <FormItem label="Title">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      required: false,
                      message: 'Name cannot be blank.'
                    }
                  ],
                  initialValue: currentContact ? currentContact.title : ''
                })(<Input />)}
              </FormItem>
              {!currentContact && (
                <FormItem label="E-mail">
                  {getFieldDecorator('email', {
                    rules: [
                      {
                        required: false,
                        message: 'Invalid E-mail.',
                        type: 'email'
                      },
                      {
                        validator: this.emailValidator
                      }
                    ],
                    validateFirst: true,
                    initialValue:
                      currentContact && currentContact.emails.length > 0
                        ? currentContact.emails[0].address
                        : ''
                  })(<Input />)}
                </FormItem>
              )}
              {!currentContact && (
                <FormItem label="Phone Number">
                  {getFieldDecorator('phone_number', {
                    rules: [
                      {
                        required: false,
                        message: 'invalid Phone Number.'
                      },
                      {
                        validator: this.phoneValidator
                      }
                    ],
                    validateFirst: true,
                    initialValue:
                      currentContact && currentContact.phone_numbers.length > 0
                        ? currentContact.phone_numbers[0].number
                        : ''
                  })(
                    <NumberFormat
                      format="(###) ###-#### ext:####"
                      mask="_"
                      onValueChange={values => {
                        this.setState({
                          phoneNumber: values.value
                        })
                      }}
                      className="ant-input"
                    />
                  )}
                </FormItem>
              )}
              {!currentContact && (
                <FormItem label="Mobile Number">
                  {getFieldDecorator('mobile_number', {
                    rules: [
                      {
                        required: false,
                        message: 'Mobile Number cannot be blank.'
                      },
                      {
                        validator: this.mobileValidator
                      }
                    ],
                    validateFirst: true,
                    initialValue: currentContact ? currentContact.mobile_number : ''
                  })(
                    <NumberFormat
                      format="(###) ###-####"
                      mask="_"
                      onValueChange={values => {
                        this.setState({
                          mobilePhoneNumber: values.value
                        })
                      }}
                      className="ant-input"
                    />
                  )}
                </FormItem>
              )}
            </Form>
            {currentContact && (
              <Fragment>
                <div className="row">
                  <div className="col-md-12">
                    <Emails
                      handleToggleEmailEditArea={this.handleToggleEmailEditArea}
                      currentEmailData={this.state.currentEmailData}
                      onChangeEmailType={this.onChangeEmailType}
                      onEmailInputChange={this.onEmailInputChange}
                      handleDeleteEmail={this.handleDeleteEmail}
                      emails={
                        this.props.contactsActions.emails && this.props.contactsActions.emails.data
                      }
                      handleRowEmailClick={this.handleRowEmailClick}
                      handleAddEditEmail={this.handleAddEditEmail}
                      emailAddEditContainer={this.state.emailAddEditContainer}
                    />
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-md-12">
                    <Phones
                      currentPhoneData={this.state.currentPhoneData}
                      phoneAddEditContainer={this.state.phoneAddEditContainer}
                      onPhoneInputChange={this.onPhoneInputChange}
                      handleTogglePhoneEditArea={this.handleTogglePhoneEditArea}
                      handleAddEditPhone={this.handleAddEditPhone}
                      phones={
                        this.props.contactsActions.phones && this.props.contactsActions.phones.data
                      }
                      phoneType={this.state.phoneType}
                      handleRowPhoneClick={this.handleRowPhoneClick}
                      handleDeletePhone={this.handleDeletePhone}
                      onChangePhoneType={this.onChangePhoneType}
                    />
                  </div>
                </div>
              </Fragment>
            )}
            <div className="row">
              <div className="col-md-6">&nbsp;</div>
            </div>
            {currentContact && (
              <Fragment>
                <div className="row">
                  <div className="col-md-12">
                    <Notes
                      // notes props
                      currentNote={this.state.currentNote}
                      currentNoteId={this.state.currentNoteId}
                      notes={
                        this.props.contactsActions.contactsNotes &&
                        this.props.contactsActions.contactsNotes.data
                      }
                      handleToggleNoteEditArea={this.handleToggleNoteEditArea}
                      noteAddEditContainer={this.state.noteAddEditContainer}
                      createNote={this.createNote}
                      handleRowNoteClick={this.handleRowNoteClick}
                      updateNote={this.updateNote}
                      userId={this.props.authentication.user.userId}
                      deleteNote={this.deleteNote}
                    />
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-md-12">
                    <Jobs
                      contactJobs={
                        this.props.contactsActions.contactJobs &&
                        this.props.contactsActions.contactJobs.data
                      }
                      handleRowJobClick={this.handleRowJobClick}
                    />
                  </div>
                </div>
                <br />
              </Fragment>
            )}
            {currentContact && (
              <div className="row">
                <div className="col-md-12">
                  <Leads
                    contactLeads={
                      this.props.contactsActions.contactLeads &&
                      this.props.contactsActions.contactLeads.data
                    }
                    handleRowLeadsClick={this.handleRowLeadsClick}
                  />
                </div>
              </div>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.handleDeleteContact}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {currentContact && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Modal>
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/contacts">Contacts</Link>
                </li>
              </ol>
            </nav>
            <h2>Contacts</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Contacts
                <div className="jobsBarAdd">
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel" onClick={() => this.handleOpenModal()}>
                    NEW CONTACT
                  </div>
                </div>
              </div>
              <ReactTable
                data={contacts.data}
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e => this.handleRowClick(rowInfo.original)
                })}
                filterable
                loading={loadingContacts}
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Company / Vendor',
                        id: 'organization_name',
                        accessor: 'organization_name',
                        Cell: props => {
                          const r = `${
                            props.original.organization_name
                              ? props.original.organization_name
                              : 'N/A'
                          }`
                          return <Tooltip title={r}>{r}</Tooltip>
                        },
                        minWidth: 160
                      },
                      {
                        Header: 'First name',
                        id: 'first_name',
                        accessor: 'first_name',
                        Cell: props => {
                          const r = `${
                            props.original.first_name ? props.original.first_name : 'N/A'
                          }`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Last name',
                        id: 'last_name',
                        accessor: 'last_name',
                        Cell: d => {
                          const r = `${d.original.last_name ? d.original.last_name : 'N/A'}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Title',
                        id: 'title',
                        accessor: 'title',
                        Cell: d => {
                          const r = `${d.original.title ? d.original.title : 'N/A'}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        },
                        minWidth: 90
                      },
                      {
                        Header: 'E-mail',
                        accessor: 'email_work',
                        Cell: d => {
                          const r = `${d.original.email_work ? d.original.email_work : 'N/A'}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        },
                        id: 'email_work'
                      },
                      {
                        Header: 'Phone Number',
                        accessor: 'phone_work',
                        id: 'phone_work',
                        minWidth: 60,
                        Cell: d => {
                          if (d.original.phone_work) {
                            return (
                              <Tooltip
                                title={
                                  <TextMask
                                    Component={SpanAdapter}
                                    value={d.original.phone_work}
                                    mask={[
                                      '(',
                                      /[1-9]/,
                                      /\d/,
                                      /\d/,
                                      ')',
                                      ' ',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      '-',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      /\d/
                                    ]}
                                    guide
                                  />
                                }
                              >
                                {
                                  <TextMask
                                    Component={SpanAdapter}
                                    value={d.original.phone_work}
                                    mask={[
                                      '(',
                                      /[1-9]/,
                                      /\d/,
                                      /\d/,
                                      ')',
                                      ' ',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      '-',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      /\d/
                                    ]}
                                    guide
                                  />
                                }
                              </Tooltip>
                            )
                          } else {
                            return 'N/A'
                          }
                        }
                      },
                      {
                        Header: 'Mobile',
                        accessor: 'phone_mobile',
                        id: 'phone_mobile',
                        minWidth: 60,
                        Cell: d => {
                          if (d.original.phone_mobile) {
                            return (
                              <Tooltip
                                title={
                                  <TextMask
                                    Component={SpanAdapter}
                                    value={d.original.phone_mobile}
                                    mask={[
                                      '(',
                                      /[1-9]/,
                                      /\d/,
                                      /\d/,
                                      ')',
                                      ' ',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      '-',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      /\d/
                                    ]}
                                    guide
                                  />
                                }
                              >
                                <TextMask
                                  Component={SpanAdapter}
                                  value={d.original.phone_mobile}
                                  mask={[
                                    '(',
                                    /[1-9]/,
                                    /\d/,
                                    /\d/,
                                    ')',
                                    ' ',
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    '-',
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/
                                  ]}
                                  guide
                                />
                              </Tooltip>
                            )
                          } else {
                            return 'N/A'
                          }
                        }
                      },
                      {
                        Header: 'Created Date',
                        id: 'created_date',
                        accessor: 'created_date',
                        minWidth: 70,
                        Cell: d => {
                          const r = moment.utc(d.original.created_date).format('M/D/YYYY')
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (
  { contactsActions, jobVendorActions, authentication, organizationsActions },
  ownProps
) => ({
  contactsActions,
  jobVendorActions,
  authentication,
  organizationsActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, vendorActions, organizationsActions), dispatch)
})

Contacts.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Contacts)))



// WEBPACK FOOTER //
// ./src/containers/contacts/index.js